import React from "react";
import { Label, Text } from "@fluentui/react";
import Select from "react-select";

const SUBUSER_OPTIONS = [
  { value: "iGradDrip", label: "iGradDrip (Marketing)" },
  { value: "iGradSandbox", label: "iGradSandbox (QA)" },
];

const selectStyles = {
  control: (provided) => ({
    ...provided,
    borderColor: "#aaaaaa",
    fontSize: 14,
    "&:hover": { borderColor: "#aaaaaa" },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#aaaaaa",
  }),
};

const SubuserSelector = ({ selectedSubusers, onSubusersChange }) => {
  return (
    <div>
      <Label required>Select Subusers</Label>
      <Select
        isMulti={true}
        options={SUBUSER_OPTIONS}
        value={selectedSubusers}
        onChange={onSubusersChange}
        placeholder="Select one or more subusers..."
        styles={selectStyles}
      />
      <Text variant="small" style={{ color: "#605E5C", marginTop: "4px" }}>
        Choose which SendGrid subusers to check for unsubscribes. iGradDrip handles marketing emails.
      </Text>
    </div>
  );
};

export default SubuserSelector;
export { SUBUSER_OPTIONS };
